import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import Button from 'src/components/core/Button/Button';
import LoadingSpinner from 'src/components/core/LoadingSpinner/LoadingSpinner';
import adminSelectors from 'src/redux/admin/admin-selectors';
import OrganizationRoleTooltip from '../Tooltips/OrganizationRoleTooltip';
import AddMemberForm from './AddMemberForm/AddMemberForm';

const AddMember = () => {
  const { t } = useTranslation();

  const [, setQuery] = useQueryParams({
    page: StringParam,
    userId: NumberParam,
  });

  const isLoading = useSelector(adminSelectors.isLoadingUsers);

  return (
    <div>
      <Button
        color={'link'}
        onClick={() =>
          setQuery({ userId: undefined, page: undefined }, 'pushIn')
        }
        icon={['far', 'arrow-left']}
        content={t('admin.go_to_team')}
      />
      {isLoading ? (
        <div className="w-100 text-center">
          <LoadingSpinner size="lg" active />
        </div>
      ) : (
        <>
          <div className="d-flex flex-row mb-4">
            <span>{t('admin.tab_team_list_helper_1')}</span>
            <OrganizationRoleTooltip width="300px" />
          </div>
          <AddMemberForm />
        </>
      )}
    </div>
  );
};

export default AddMember;
